export default {
  methods: {
    mapInsulinTypes(type) {
      let self = this;
      let label = '';
      switch (type) {
        case 'Basal' :
          label = self.$t('message.labelBasal');
          break;
        case 'Bolus' :
          label = self.$t('message.labelBolus');
          break;
        case 'Correction' :
          label = self.$t('message.labelCorrection');
          break;
      }
      return label;
    },
  },
  computed: {
    lowerCaseUnitsLabel() {
      let self = this;
      return self.$t('message.labelUnits').toLowerCase();
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/InsulinMixin/index.js